// import HeroSection from "../components/HeroSection";

// export default function Home() {
//   return (
//     <main>
//       <HeroSection />

//       {/* About Us */}
// <section id="about" className="bg-white">
//   <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
//     <div className="grid lg:grid-cols-2 gap-10 items-center">
//       {/* Text */}
//       <div>
       
//         <h2 className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0a1220]">
//           About Us
//         </h2>
//         <p className="mt-4 text-slate-700 leading-relaxed">
//           We are an eco-friendly, solar-powered car wash offering three
//           spacious self-serve bays with a dedicated bay to accommodate large
//           Recreational Vehicles. We also offer a powerful, dirt-busting,
//           touch-free automatic wash for your convenience. Our detail vending
//           machine carries many of the items to make your vehicle clean on the
//           inside and out and our vacuums will finish the job!
//         </p>

//         {/* quick highlights */}
//         <ul className="mt-6 grid sm:grid-cols-2 gap-3 text-slate-700">
//           <li className="flex items-start gap-2">
//             <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//             Solar-powered facility
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//             3 self-serve bays + RV bay
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//             Touch-free automatic wash
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//             Detail vending + powerful vacuums
//           </li>
//         </ul>

//         {/* CTAs */}
//         <div className="mt-8 flex flex-wrap gap-3">
//           <a
//             href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//             target="_blank" rel="noreferrer"
//             className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
//           >
//             Get Directions
//           </a>
//           <a
//             href="tel:15305293002"
//             className="px-6 py-3 rounded-lg border border-slate-300 text-[#0a1220] hover:bg-slate-50"
//           >
//             Call (530) 529-3002
//           </a>
//         </div>
//       </div>

   
//     </div>
//   </div>
// </section>

//     </main>
//   );
// }








// import HeroSection from "../components/HeroSection";
// import { Link } from "react-router-dom";

// export default function Home() {
//   return (
//     <main>
//       <HeroSection />

//       {/* ============ About Us ============ */}
//       <section id="about" className="bg-white">
//         <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
//           <h2 className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0a1220]">
//             About Us
//           </h2>
//           <p className="mt-4 text-slate-700 leading-relaxed">
//             We are an eco-friendly, solar-powered car wash offering three
//             spacious self-serve bays with a dedicated bay to accommodate large
//             Recreational Vehicles. We also offer a powerful, dirt-busting,
//             touch-free automatic wash for your convenience. Our detail vending
//             machine carries many of the items to make your vehicle clean on the
//             inside and out and our vacuums will finish the job!
//           </p>

//           {/* quick highlights */}
//           <ul className="mt-6 grid sm:grid-cols-2 gap-3 text-slate-700">
//             <li className="flex items-start gap-2">
//               <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//               Solar-powered facility
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//               3 self-serve bays + RV bay
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//               Touch-free automatic wash
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
//               Detail vending + powerful vacuums
//             </li>
//           </ul>

//           {/* CTAs */}
//           <div className="mt-8 flex flex-wrap gap-3">
//             <a
//               href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//               target="_blank"
//               rel="noreferrer"
//               className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
//             >
//               Get Directions
//             </a>
//             <a
//               href="tel:15305293002"
//               className="px-6 py-3 rounded-lg border border-slate-300 text-[#0a1220] hover:bg-slate-50"
//             >
//               Call (530) 529-3002
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* ============ Contact (on Home) — moved before Services ============ */}
//       <section id="contact" className="bg-[#0a1220]">
//         <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
//           <div className="grid lg:grid-cols-3 gap-8 items-center">
//             {/* Left: Headline + CTA */}
//             <div className="lg:col-span-1">
//               <h2 className="text-3xl md:text-4xl font-extrabold text-white">
//                 Ready for a Clean Car?
//               </h2>
//               <p className="mt-3 text-white/80">Open 24/7 • Red Bluff, CA</p>
//               <div className="mt-6 flex flex-wrap gap-3">
//                 <a
//                   href="tel:15305293002"
//                   className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
//                   aria-label="Call Main Street Car Wash"
//                 >
//                   Call (530) 529-3002
//                 </a>
//                 <Link
//                   to="/contact"
//                   className="px-6 py-3 rounded-lg border border-white/20 text-white hover:bg-white/10"
//                 >
//                   Message Us
//                 </Link>
//               </div>
//             </div>

//             {/* Middle/right: Info pills */}
//             <div className="lg:col-span-2 grid sm:grid-cols-3 gap-4">
//               <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
//                 <div className="flex items-center gap-2 text-cyan-300 font-semibold">
//                   <ClockIcon className="h-5 w-5" /> Hours
//                 </div>
//                 <p className="mt-2 text-white/85">Open 24 Hours, 7 Days a Week</p>
//               </div>
//               <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
//                 <div className="flex items-center gap-2 text-cyan-300 font-semibold">
//                   <MapPinIcon className="h-5 w-5" /> Address
//                 </div>
//                 <a
//                   href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="mt-2 inline-block text-white/85 hover:underline"
//                 >
//                   409 Main Street, Red Bluff, CA
//                 </a>
//               </div>
//               <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
//                 <div className="flex items-center gap-2 text-cyan-300 font-semibold">
//                   <ShieldIcon className="h-5 w-5" /> Touch-Free
//                 </div>
//                 <p className="mt-2 text-white/85">
//                   Automatic • Self-Serve • Vacuums
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ============ Services (on Home) — text only, no images ============ */}
//       <section id="services" className="bg-white">
//         <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
//           <div className="text-center">
//             <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1220]">
//               Our Services
//             </h2>
//             <div className="mt-4 flex justify-center">
//               <span className="h-1.5 w-28 rounded-full bg-cyan-400" />
//             </div>
//             <p className="mt-4 text-slate-600">
//               Fast touch-free wash • Self-serve bays • Oversize RV bay • Vacuums • Vending
//             </p>
//           </div>

//           {/* Three main service blocks */}
//           <div className="mt-12 space-y-10">
//             <div className="grid lg:grid-cols-3 gap-6 items-start">
//               <div className="lg:col-span-1">
//                 <span className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-600">
//                   <DropletsIcon className="h-4 w-4" /> Exterior
//                 </span>
//                 <h3 className="mt-3 text-2xl font-extrabold text-[#0a1220]">
//                   Automatic Wash
//                 </h3>
//                 <div className="mt-3 h-1 w-16 bg-cyan-400 rounded-full" />
//               </div>
//               <p className="lg:col-span-2 text-slate-700 leading-relaxed">
//                 Pamper your vehicle with our fast, touch-free automatic wash—
//                 designed to lift dirt without brushes and finish with a spotless rinse.
//               </p>
//             </div>

//             <div className="grid lg:grid-cols-3 gap-6 items-start">
//               <div className="lg:col-span-1">
//                 <span className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-600">
//                   <SprayIcon className="h-4 w-4" /> Exterior
//                 </span>
//                 <h3 className="mt-3 text-2xl font-extrabold text-[#0a1220]">
//                   Self-Serve Bays
//                 </h3>
//                 <div className="mt-3 h-1 w-16 bg-cyan-400 rounded-full" />
//               </div>
//               <p className="lg:col-span-2 text-slate-700 leading-relaxed">
//                 Spacious bays with pro-grade wands, foam brush, and cleaners so you
//                 can hit every angle—your pace, your way.
//               </p>
//             </div>

//             <div className="grid lg:grid-cols-3 gap-6 items-start">
//               <div className="lg:col-span-1">
//                 <span className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-600">
//                   <TruckIcon className="h-4 w-4" /> Oversize
//                 </span>
//                 <h3 className="mt-3 text-2xl font-extrabold text-[#0a1220]">
//                   Truck / RV / Auto Wash Bay
//                 </h3>
//                 <div className="mt-3 h-1 w-16 bg-cyan-400 rounded-full" />
//               </div>
//               <p className="lg:col-span-2 text-slate-700 leading-relaxed">
//                 Extra-large bay engineered to accommodate large Recreational
//                 Vehicles and lifted trucks—easy in, easy out.
//               </p>
//             </div>
//           </div>

//           {/* Mini tiles (still text-only) */}
//           <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
//             {[
//               {
//                 title: "Self-Serve Vacuums",
//                 text: "Finish the job with powerful suction and crevice tools.",
//                 icon: <VacuumIcon className="h-5 w-5" />,
//               },
//               {
//                 title: "Vending Detail Center",
//                 text: "Microfiber, glass wipes, fragrances, and more—on site.",
//                 icon: <VendingIcon className="h-5 w-5" />,
//               },
//               {
//                 title: "Eco-Forward",
//                 text: "Solar-powered facility and water-wise process.",
//                 icon: <LeafIcon className="h-5 w-5" />,
//               },
//             ].map((it, i) => (
//               <div
//                 key={i}
//                 className="rounded-2xl p-6 ring-1 ring-slate-200 bg-white hover:shadow-md transition"
//               >
//                 <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold">
//                   <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-cyan-50">
//                     {it.icon}
//                   </span>
//                   <span>{it.title}</span>
//                 </div>
//                 <p className="mt-3 text-slate-700">{it.text}</p>
//               </div>
//             ))}
//           </div>

//           {/* Links to deeper pages */}
//           <div className="mt-12 flex flex-wrap gap-4 justify-center">
//             <Link
//               to="/pricing"
//               className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
//             >
//               View Pricing
//             </Link>
//             <Link
//               to="/services"
//               className="px-6 py-3 rounded-lg border border-slate-300 text-[#0a1220] hover:bg-slate-50"
//             >
//               See All Services
//             </Link>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

// /* ============ Inline Icons ============ */
// function DropletsIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M7 11c0 3.314 2.239 6 5 6s5-2.686 5-6c0-3.314-5-8-5-8s-5 4.686-5 8Z"
//         stroke="currentColor"
//         strokeWidth="1.6"
//       />
//     </svg>
//   );
// }
// function SprayIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M5 10h8M5 14h6M15 7h4M15 11h4M15 15h4"
//         stroke="currentColor"
//         strokeWidth="1.6"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }
// function TruckIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path d="M3 7h10v8H3zM13 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.6" />
//       <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.6" />
//       <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.6" />
//     </svg>
//   );
// }
// function VacuumIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M6 18h8l2-6a4 4 0 0 0-7.8-2"
//         stroke="currentColor"
//         strokeWidth="1.6"
//       />
//       <path d="M4 18h14v2H4z" stroke="currentColor" strokeWidth="1.6" />
//     </svg>
//   );
// }
// function VendingIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <rect
//         x="5"
//         y="3"
//         width="14"
//         height="18"
//         rx="1.5"
//         stroke="currentColor"
//         strokeWidth="1.6"
//       />
//       <path
//         d="M8 7h3M8 10h3M8 13h3M13 7h3M13 10h3M13 13h3"
//         stroke="currentColor"
//         strokeWidth="1.6"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }
// function LeafIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M19 5s-6 0-10 4-4 10-4 10 6 0 10-4 4-10 4-10Z"
//         stroke="currentColor"
//         strokeWidth="1.6"
//       />
//       <path d="M9 15l6-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
//     </svg>
//   );
// }
// function ClockIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
//       <path
//         d="M12 7v5l3 2"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }
// function MapPinIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//       <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.8" />
//     </svg>
//   );
// }
// function ShieldIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3z"
//         stroke="currentColor"
//         strokeWidth="1.6"
//       />
//     </svg>
//   );
// }


import HeroSection from "../components/HeroSection";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <main>
      <HeroSection />

      {/* ============ About Us ============ */}
      <section id="about" className="bg-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0a1220]">
            About Us
          </h2>
          <p className="mt-4 text-slate-700 leading-relaxed">
            We are an eco-friendly, solar-powered car wash offering three
            spacious self-serve bays with a dedicated bay to accommodate large
            Recreational Vehicles. We also offer a powerful, dirt-busting,
            touch-free automatic wash for your convenience. Our detail vending
            machine carries many of the items to make your vehicle clean on the
            inside and out and our vacuums will finish the job!
          </p>

          {/* quick highlights */}
          <ul className="mt-6 grid sm:grid-cols-2 gap-3 text-slate-700">
            <li className="flex items-start gap-2">
              <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
              Solar-powered facility
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
              3 self-serve bays + RV bay
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
              Touch-free automatic wash
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-2.5 w-2.5 rounded-full bg-cyan-400" />
              Detail vending + powerful vacuums
            </li>
          </ul>

          {/* CTAs */}
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
              target="_blank"
              rel="noreferrer"
              className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
            >
              Get Directions
            </a>
            <a
              href="tel:15305293002"
              className="px-6 py-3 rounded-lg border border-slate-300 text-[#0a1220] hover:bg-slate-50"
            >
              Call (530) 529-3002
            </a>
          </div>
        </div>
      </section>

      {/* ============ Contact (on Home) — no buttons now ============ */}
      <section id="contact" className="bg-[#0a1220]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-3 gap-8 items-center">
            {/* Left: Headline */}
            <div className="lg:col-span-1">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white">
                Ready for a Clean Car?
              </h2>
              <p className="mt-3 text-white/80">Open 24/7 • Red Bluff, CA</p>
            </div>

            {/* Middle/right: Info pills */}
            <div className="lg:col-span-2 grid sm:grid-cols-3 gap-4">
              <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                <div className="flex items-center gap-2 text-cyan-300 font-semibold">
                  <ClockIcon className="h-5 w-5" /> Hours
                </div>
                <p className="mt-2 text-white/85">Open 24 Hours, 7 Days a Week</p>
              </div>
              <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                <div className="flex items-center gap-2 text-cyan-300 font-semibold">
                  <MapPinIcon className="h-5 w-5" /> Address
                </div>
                <a
                  href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 inline-block text-white/85 hover:underline"
                >
                  409 Main Street, Red Bluff, CA
                </a>
              </div>
              <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                <div className="flex items-center gap-2 text-cyan-300 font-semibold">
                  <ShieldIcon className="h-5 w-5" /> Touch-Free
                </div>
                <p className="mt-2 text-white/85">
                  Automatic • Self-Serve • Vacuums
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ Services (on Home) — simplified, less crowded ============ */}
      <section id="services" className="bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1220]">
              Our Services
            </h2>
            <div className="mt-4 flex justify-center">
              <span className="h-1.5 w-28 rounded-full bg-cyan-400" />
            </div>
            <p className="mt-4 text-slate-600 max-w-2xl mx-auto">
              Fast touch-free automatic wash, spacious self-serve bays, an
              oversize RV bay, vacuums, and a fully stocked vending detail center.
            </p>
          </div>

          {/* Three simple cards */}
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <DropletsIcon className="h-4 w-4" />
                Exterior
              </div>
              <h3 className="mt-3 text-xl font-extrabold text-[#0a1220]">
                Automatic Wash
              </h3>
              <p className="mt-3 text-slate-700 text-sm leading-relaxed">
                Fast, touch-free automatic wash designed to lift dirt
                without brushes and finish with a spotless rinse.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <SprayIcon className="h-4 w-4" />
                Exterior
              </div>
              <h3 className="mt-3 text-xl font-extrabold text-[#0a1220]">
                Self-Serve Bays
              </h3>
              <p className="mt-3 text-slate-700 text-sm leading-relaxed">
                Spacious bays with pro-grade wands, hog hair foam brush, and cleaners
                so you can wash your way, at your own pace.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <TruckIcon className="h-4 w-4" />
                Oversize
              </div>
              <h3 className="mt-3 text-xl font-extrabold text-[#0a1220]">
                Truck / RV Bay
              </h3>
              <p className="mt-3 text-slate-700 text-sm leading-relaxed">
                Extra-large bay engineered to accommodate large RVs, trailers,
                and lifted trucks—easy in, easy out.
              </p>
            </div>
          </div>

          {/* Single row of small extras */}
          <div className="mt-12 grid gap-4 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-5 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <VacuumIcon className="h-4 w-4" />
                Vacuums
              </div>
              <p className="mt-2 text-slate-700 text-sm">
                Powerful self-serve vacuums to finish the inside.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-5 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <VendingIcon className="h-4 w-4" />
                Detail Center
              </div>
              <p className="mt-2 text-slate-700 text-sm">
                Vending machine stocked with towels, wipes, and more.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-5 text-left">
              <div className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-sm">
                <LeafIcon className="h-4 w-4" />
                Eco-Friendly
              </div>
              <p className="mt-2 text-slate-700 text-sm">
                Solar-powered facility with water-wise processes.
              </p>
            </div>
          </div>

          {/* Links to deeper pages */}
          <div className="mt-12 flex flex-wrap gap-4 justify-center">
            <Link
              to="/pricing"
              className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
            >
              View Pricing
            </Link>
            <Link
              to="/services"
              className="px-6 py-3 rounded-lg border border-slate-300 text-[#0a1220] hover:bg-slate-50"
            >
              See All Services
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

/* ============ Inline Icons ============ */
function DropletsIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7 11c0 3.314 2.239 6 5 6s5-2.686 5-6c0-3.314-5-8-5-8s-5 4.686-5 8Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}
function SprayIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M5 10h8M5 14h6M15 7h4M15 11h4M15 15h4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
function TruckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 7h10v8H3zM13 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}
function VacuumIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6 18h8l2-6a4 4 0 0 0-7.8-2"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path d="M4 18h14v2H4z" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}
function VendingIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect
        x="5"
        y="3"
        width="14"
        height="18"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M8 7h3M8 10h3M8 13h3M13 7h3M13 10h3M13 13h3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
function LeafIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M19 5s-6 0-10 4-4 10-4 10 6 0 10-4 4-10 4-10Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path d="M9 15l6-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
function ClockIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 7v5l3 2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
function MapPinIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}
function ShieldIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}
